// MasterContext.tsx
import React, { createContext, useContext, useState, useEffect } from "react";
import { useEnvironment } from "./EnvironmentContext";

// const MasterContext = createContext<boolean>(false);

interface MasterContextType {
  isMaster: boolean;
  refreshEnvStatus: () => void;
}

const MasterContext = createContext<MasterContextType>({
  isMaster: false,
  refreshEnvStatus: () => {},
});

export const MasterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isMaster, setIsMaster] = useState<boolean>(false);
  const [refreshToken, setRefreshToken] = useState<number>(0);
  const { environments, activeEnvironmentId } = useEnvironment();

  useEffect(() => {
    if (!activeEnvironmentId) {
      setIsMaster(false);
      return;
    }

    const matchedEnvironment = environments.find(
      (environment) => environment.environment_id === activeEnvironmentId
    );

    setIsMaster(Boolean(matchedEnvironment?.is_master));
  }, [activeEnvironmentId, environments, refreshToken]);

  const refreshEnvStatus = () => {
    setRefreshToken((prev) => prev + 1);
  };

  return <MasterContext.Provider value={{ isMaster, refreshEnvStatus }}>{children}</MasterContext.Provider>;
};

// Hook to consume
export const useMaster = () => useContext(MasterContext);
